<template>
    <v-content class="bg-content">
    <v-container>
      <form @submit.prevent="submitResearchQuery">
        <v-text-field v-model="researchQuery.title" label="Report Name" required></v-text-field>
        <v-text-field v-model="researchQuery.subject" label="Report Subject" required></v-text-field>
        <v-textarea v-model="researchQuery.notes" label="Research Notes" rows="3"></v-textarea>
        <v-text-field v-model="researchQuery.websites" label="Research Website URLs (comma-separated)" required></v-text-field>
        <v-select v-model="researchQuery.reportType" :items="reportTypes" label="Report Type" required></v-select>
        <v-select v-model="researchQuery.length" :items="reportLengths" label="Length" required></v-select>
        <v-select v-model="researchQuery.documentType" :items="documentTypes" label="Document Type" required></v-select>
        
        <v-btn class="mx-2" @click="promptUserAndStartRecording">Start Voice Input</v-btn>
        <v-btn type="submit" color="primary">Submit Research Query</v-btn>
        <v-btn @click="resetForm">Reset</v-btn>
      </form>
    </v-container>
    <v-container fluid>
    <v-layout row wrap class="card-animate-2" style="margin-top: 20px; padding: 30px;">
      <v-flex xs12 sm12 md12 xl9>
        <vue-editor id="editor"
                    useCustomImageHandler
                    @imageAdded="handleImageAdded"
                    v-model="reportContent">
        </vue-editor>
      </v-flex>
      <v-flex xs12 sm12 md12 xl3>
        <v-form ref="emailForm"
                lazy-validation
                aria-autocomplete="off"
                style="padding: 10px; margin-top: 10px;">
          <v-row>
            <v-col cols="12">
              <v-text-field label="Email" type="email" v-model="email" required></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-btn color="primary" @click="sendEmail">Send Report</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>

    <saved-research-list :saved-research="savedResearch" @edit-research="editSavedResearch" @delete-research="deleteSavedResearch"></saved-research-list>
  </v-content>
</template>

<script>
import SavedResearchList from "../components/SavedResearchAssistList.vue";
import submitAudio from '../assets/audio/input1.wav';
import codeCompleteAudio from "../assets/audio/SelectNew.wav";
import { VueEditor } from 'vue2-editor';
// Import any additional necessary libraries here

export default {
  components: {
    SavedResearchList,
    VueEditor,
  },
  data() {
    return {
      reportContent: '', // Content of the report to be displayed in the editor
      email: '', // Email address to send the report to
      researchQuery: {
        title: '',
        subject: '',
        notes: '',
        websites: '', // This will be split into an array when processing the form
        reportType: '',
        length: '',
        documentType: '',
      },
      savedResearch: JSON.parse(localStorage.getItem("savedResearch") || "[]"),
      reportTypes: ["Research Paper", "Proposal", "Request for Proposal", "Outline", "Business Plan"],
      reportLengths: ["Short (1 to 2 Pages)", "Medium (2 to 4 Pages)", "Long (4 to 6 Pages)", "Detailed (6+ Pages)"],
      documentTypes: ["PDF", "Word"],
      isRecording: false,
      recordingStateColor: 'green', // Initial color for the recording icon
    };
  },
  methods: {
    handleImageAdded() {
      // Handle custom image added event if necessary
    },
    async sendEmail() {
      // Implement functionality to send the report content via email
      // This could involve sending the content to your backend server, which then emails the report
      console.log("Sending email to:", this.email);
      // Reset form after sending
      this.email = '';
    },
    promptUserAndStartRecording() {
      this.readOutLoud('What can I help you research?');
  setTimeout(() => {
    this.isRecording = true;
    this.recordingStateColor = 'green';
    this.startRecording();
  }, 2000);
},
startRecording() {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SpeechRecognition();
  recognition.lang = 'en-US';
  recognition.continuous = true; // Keep the microphone open
  recognition.start();

  let finalTranscript = ''; // To store the final transcript
  let lastUpdateTime = Date.now(); // To track the last time the transcript was updated

  recognition.onstart = () => {
    this.recordingStateColor = 'blue'; // Color when user is speaking
  };

  recognition.onresult = (event) => {
    let interimTranscript = '';
    for (let i = event.resultIndex; i < event.results.length; ++i) {
      if (event.results[i].isFinal) {
        finalTranscript += event.results[i][0].transcript;
      } else {
        interimTranscript += event.results[i][0].transcript;
      }
    }
    this.queryPrompt = finalTranscript + interimTranscript;
    lastUpdateTime = Date.now();

    // If the user has stopped speaking for 3 seconds, stop recording
    setTimeout(() => {
      if (Date.now() - lastUpdateTime > 3000) {
        recognition.stop();
      }
    }, 3000);
  };

  recognition.onend = () => {
    this.recordingStateColor = 'red'; // Color just before submitting
    this.isRecording = false;
    this.submitQuery();
  };

  recognition.onerror = (event) => {
    console.error('Speech recognition error', event);
    this.isRecording = false;
  };

  this.isRecording = true;

  // Stop recording automatically after 10 seconds of speech
  setTimeout(() => {
    if (this.isRecording) {
      recognition.stop();
    }
  }, 15000);
},
    readOutLoud(message) {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = message;
      window.speechSynthesis.speak(speech);

    },
    async submitResearchQuery() {
  // Validate the form input
  if (!this.researchQuery.title || !this.researchQuery.subject || !this.researchQuery.websites) {
    alert("Please complete all required fields.");
    return;
  }

  // Convert comma-separated websites into an array
  const websitesArray = this.researchQuery.websites.split(",").map(website => website.trim());

  // Prepare the data to be sent
  const requestData = {
    title: this.researchQuery.title,
    subject: this.researchQuery.subject,
    notes: this.researchQuery.notes,
    websites: websitesArray,
    reportType: this.researchQuery.reportType,
    length: this.researchQuery.length,
    documentType: this.researchQuery.documentType,
  };

  this.loading = true;
  new Audio(submitAudio).play(); // Play submit audio feedback

  let seconds = 0;
  this.readOutLoud(`Generating report...`);
  const interval = setInterval(() => {
    this.loadingText = `Generating report... (${++seconds}s)`;
  }, 1000);

  try {
    const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
      method: 'POST',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      throw new Error("Failed to generate report");
    }

    const data = await response.json();
    // Assuming the response includes a URL to the generated report
    const reportUrl = data.reportUrl;

    // Clear loading state and interval
    clearInterval(interval);
    this.loadingText = '';

    new Audio(codeCompleteAudio).play(); // Play completion audio feedback

    // Use SpeechSynthesis to announce completion
    const speechSynthesis = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance("Your report has been generated.");
    speechSynthesis.speak(utterance);

    // Handle the generated report URL (e.g., display it, allow downloading, etc.)
    console.log("Generated report URL:", reportUrl);
    // Update the UI accordingly
    this.generatedReportUrl = reportUrl; // You might want to add this property to your data

  } catch (error) {
    console.error('Error generating report:', error);
    alert("There was an error generating the report.");
    clearInterval(interval);
    this.loadingText = '';
  } finally {
    this.loading = false;
  }
},
    resetForm() {
      // Reset the form fields to their default state
      this.researchQuery = { title: '', subject: '', notes: '', websites: '', reportType: '', length: '', documentType: '' };
    },
    editSavedResearch(index) {
      // Load the selected research data into the form for editing
      const research = this.savedResearch[index];
      this.researchQuery = { ...research };
    },
    deleteSavedResearch(index) {
      // Remove the selected research from the saved list and update localStorage
      this.savedResearch.splice(index, 1);
      localStorage.setItem("savedResearch", JSON.stringify(this.savedResearch));
    },
  },
  mounted() {
    // Initialize components, such as setting up the ace editor if needed or preparing speech synthesis
  },
};
</script>
<style scoped>
/* Layout and Animation Enhancements */
.card-animate-2 {
  transition: box-shadow .3s ease-in-out, transform .3s ease-in-out;
  &:hover {
    box-shadow: 0 8px 16px rgba(0,0,0,.1);
    transform: translateY(-2px);
  }
}

/* Editor and Form Styling */
#editor {
  border: 1px solid #ddd;
  border-radius: 4px;
  /* Enhance the editor's contrast against the background */
  background-color: #fff;
}

/* Button and Form Field Enhancements */
.v-button {
  background-color: #1976D2;
  color: white;
  
  &:hover {
    background-color: darken(#1976D2, 10%);
  }
}

.chart-title, .chart-title-4 {
  width: 100%;
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box; /* Makes the padding not affect the final computed width */
}

/* Loading, Success, and Error Feedback */
.loading, .submit, .check {
  display: inline-block;
  margin-left: 10px;
}

.fa-spinner, .fa-check {
  color: #1976D2;
}

/* Dialog and Confirmation Styles */
.v-dialog .theme-bg-card-6 {
  background-color: #ECEFF1;
  color: #263238; /* Dark grey that enhances readability */
}

/* Responsive adjustments for smaller screens */
@media (max-width: 600px) {
  .v-layout.row.wrap {
    flex-direction: column;
    padding: 15px;
  }

  .v-flex {
    margin-bottom: 20px; /* Add space between stacked elements */
  }

  .v-dialog {
    width: 90% !important; /* Ensure dialogs are not too wide on small screens */
  }
}
</style>
